import { useCallback } from 'react';

import { useAtomValue } from 'jotai';

import { useTranslate } from '@i18n';
import { uiNodesMapAtom } from '@store';

export const useUiNodeTitle = () => {
    const uiNodesMap = useAtomValue(uiNodesMapAtom);
    const t = useTranslate();
    const getTitle = useCallback(
        (nodeId: string | null | undefined, defaultTitle = '-') => {
            const node = nodeId ? uiNodesMap?.[nodeId] : null;
            return t(node?.i18n ?? defaultTitle);
        },
        [t, uiNodesMap],
    );

    return getTitle;
};
